import React, { useEffect } from "react";
import { Link } from "react-router-dom";

// ✅ Background
import projectBg from "../../images/bg/project-bg.png";

// ✅ Product dashboard backgrounds
import imgDealFlow from "../../images/projects/dealflow.png";
import imgCartify from "../../images/projects/cartify.png";
import imgLms from "../../images/projects/lms.png";

import { products } from "../../data/products";

const imageMap: Record<string, string> = {
  dealflow: imgDealFlow,
  cartify: imgCartify,
  lms: imgLms,
};

const arrow = (
  <span className="arrow">
    <span className="arrow-icon">
      {[...Array(2)].map((_, i) => (
        <svg key={i} width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="5.06592" y="19.9785" width="20.5712" height="2.61221" transform="rotate(-40.2798 5.06592 19.9785)" fill="white" />
          <rect x="7.97095" y="7.24463" width="2.61221" height="2.61221" transform="rotate(-40.2798 7.97095 7.24463)" fill="white" />
          <rect x="11.6523" y="7.54834" width="2.61221" height="2.61221" transform="rotate(-40.2798 11.6523 7.54834)" fill="white" />
          <rect x="15.334" y="7.85205" width="2.61221" height="2.61221" transform="rotate(-40.2798 15.334 7.85205)" fill="white" />
          <rect x="18.7119" y="11.8374" width="2.61221" height="2.61221" transform="rotate(-40.2798 18.7119 11.8374)" fill="white" />
          <rect x="18.4084" y="15.52" width="2.61221" height="2.61221" transform="rotate(-40.2798 18.4084 15.52)" fill="white" />
          <rect x="18.104" y="19.2012" width="2.61221" height="2.61221" transform="rotate(-40.2798 18.104 19.2012)" fill="white" />
        </svg>
      ))}
    </span>
  </span>
);

const ProjectSection: React.FC = () => {
  useEffect(() => {
    const bgElement = document.querySelector<HTMLElement>(".project.bg_img");
    if (bgElement) bgElement.style.backgroundImage = `url(${projectBg})`;

    const items = document.querySelectorAll<HTMLElement>(".xb-project-item");
    const paginations = document.querySelectorAll<HTMLElement>(".xb-project-pagination li");
    if (!items.length || !paginations.length) return;

    items.forEach((item) => {
      item.style.transition = "opacity 0.6s ease";
      item.style.opacity = "1";
    });

    const updateActive = () => {
      let indexToActivate = 0;
      const triggerLine = window.innerHeight * 0.3;
      items.forEach((item, index) => {
        if (item.getBoundingClientRect().top <= triggerLine) indexToActivate = index;
      });
      paginations.forEach((el) => el.classList.remove("active"));
      if (paginations[indexToActivate]) paginations[indexToActivate].classList.add("active");
      items.forEach((item, i) => {
        item.style.opacity = i < indexToActivate ? "0.3" : "1";
      });
    };

    window.addEventListener("scroll", updateActive);
    updateActive();
    return () => window.removeEventListener("scroll", updateActive);
  }, []);

  return (
    <section className="project bg_img pt-135 pb-150">
      <div className="container">
        <div className="sec-title custom-sec-title xb-sec-padding text-center">
          <span className="sub-title">Our Work</span>
          <h2 className="title">Products we've built and shipped</h2>
        </div>
      </div>

      <div className="container mxw-1800">
        <div className="xb-project-wrap">
          {/* Pagination */}
          <div className="xb-project-pagination-wrap">
            <ul className="xb-project-pagination">
              {products.map((_, i) => (
                <li key={i} className={i === 0 ? "active" : ""}>
                  {i + 1}
                </li>
              ))}
            </ul>
          </div>

          {/* Product items */}
          <div className="xb-project-inner">
            {products.map((product) => (
              <div
                key={product.slug}
                className="xb-project-item bg_img"
                style={{ backgroundImage: `url(${imageMap[product.image]})` }}
              >
                <div className="xb-project-content">
                  <div className="xb-item--inner xb-border">
                    <span className="xb-item--tagline">{product.tagline}</span>
                    <h2 className="xb-item--title">{product.name}</h2>
                    <p className="xb-item--content">{product.summary}</p>
                    <ul className="xb-item--list ul_li">
                      <li>
                        Industry: <span>{product.industry}</span>
                      </li>
                      <li>
                        Platform: <span>{product.platform}</span>
                      </li>
                    </ul>
                    <div className="xb-item---btn mt-40">
                      <Link className="thm-btn agency-btn" to={`/work/${product.slug}`}>
                        <span className="text">view complete product</span>
                        {arrow}
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProjectSection;
